import { gql } from '@apollo/client';

export interface ProcedureStatusColor {
  status: string;
  color: string;
  flash?: boolean;
  excludeFromSchedule?: boolean;
  excludeFromMonitor?: boolean;
}

export const procedureStatusColorsQuery = gql`
  query procedureStatusColors {
    procedureStatusColors {
      status
      color
      flash
      excludeFromSchedule
      excludeFromMonitor
    }
  }
`;

export const setProcedureStatusColorsMutation = gql`
  mutation setProcedureStatusColors($colors: [ProcedureStatusColorInput!]!) {
    setProcedureStatusColors(colors: $colors) {
      status
      color
      flash
      excludeFromSchedule
      excludeFromMonitor
    }
  }
`;

export default {
  list: procedureStatusColorsQuery,
  set: setProcedureStatusColorsMutation,
};
